/* Asfar Al-Ummah — package card rendering + filtering (NL / AR / EN / FR) */
(function () {
  "use strict";

  function currentLang() {
    return document.documentElement.getAttribute("data-lang") || "nl";
  }
  function t(field) {
    var lang = currentLang();
    return field[lang] || field.nl;
  }
  function priceFmt(n) {
    return "€" + n.toLocaleString("nl-NL");
  }
  var CONTACT_PATH = window.ASFAR_CONTACT_PATH || "contact.html";

  var UI = {
    vanaf: { nl: "vanaf", ar: "ابتداءً من", en: "from", fr: "à partir de" },
    voegFoto: { nl: "Voeg hier je foto toe (", ar: "أضف صورة هنا (", en: "Add your photo here (", fr: "Ajoutez votre photo ici (" },
    mekka: { nl: "Mekka", ar: "مكة", en: "Makkah", fr: "La Mecque" },
    visum: { nl: "Visum inbegrepen", ar: "التأشيرة مشمولة", en: "Visa included", fr: "Visa inclus" },
    hotel: { nl: "hotel", ar: "فندق", en: "hotel", fr: "hôtel" },
    ontbijt: { nl: "Incl. ontbijt, diner optioneel", ar: "شامل الإفطار، العشاء اختياري", en: "Breakfast incl., dinner optional", fr: "Petit-déjeuner incl., dîner en option" },
    transport: { nl: "Transport & excursies", ar: "النقل والرحلات مشمولة", en: "Transport & excursions", fr: "Transport et excursions" },
    perPersoon: { nl: "per persoon", ar: "للشخص", en: "per person", fr: "par personne" },
    boekReis: { nl: "Boek een reis", ar: "احجز الآن", en: "Book this trip", fr: "Réserver ce voyage" },
    geenReizen: { nl: "Geen reizen gevonden voor deze filters.", ar: "لا توجد نتائج تطابق هذا الفلتر.", en: "No trips found for these filters.", fr: "Aucun voyage trouvé pour ces filtres." },
    reisGevonden: { nl: "reis gevonden", ar: "نتيجة", en: "trip found", fr: "voyage trouvé" },
    reizenGevonden: { nl: "reizen gevonden", ar: "نتيجة", en: "trips found", fr: "voyages trouvés" }
  };
  function ui(key) { return UI[key][currentLang()] || UI[key].nl; }

  function photoPlaceholder(pkg, extraClass) {
    return (
      '<div class="photo-ph' + (extraClass ? " " + extraClass : "") + '" data-src="' + pkg.photo + '" data-alt="' + t(pkg.title) + '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.5" cy="10.5" r="1.5"/><path d="M21 15l-5-5L5 19"/></svg>' +
      '<span class="i18n-static">' + ui("voegFoto") + pkg.photo + ")</span>" +
      "</div>"
    );
  }

  var planeIcon = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M2 16l20-6-7 14-2-7-7-1z"/></svg>';
  var calIcon = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>';
  var pinIcon = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>';
  var ticketIcon = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9a2 2 0 0 1 0-4h18a2 2 0 0 1 0 4 2 2 0 0 0 0 4 2 2 0 0 1 0 4H3a2 2 0 0 1 0-4 2 2 0 0 0 0-4z"/></svg>';
  var bedIcon = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18v-7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v7M3 18v2M21 18v2M3 13h18"/></svg>';
  var mealIcon = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2v7a2 2 0 0 0 4 0V2M8 9v13M18 2c-2 2-2 4-2 6s0 4 2 4 2-2 2-4V2z"/></svg>';
  var busIcon = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="13" rx="2"/><path d="M3 12h18M7 20v-3M17 20v-3"/></svg>';
  var sunIcon = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>';

  function renderHomePreview(containerId, limit) {
    var el = document.getElementById(containerId);
    if (!el || typeof ASFAR_PACKAGES === "undefined") return;
    var items = ASFAR_PACKAGES.slice(0, limit || 6);
    el.innerHTML = items.map(function (pkg, i) {
      return (
        '<div class="pkg-preview-card reveal" style="transition-delay:' + (i * 70) + 'ms">' +
        '<div class="pkg-preview-photo">' +
        '<span class="badge">' + t(pkg.badge) + "</span>" +
        photoPlaceholder(pkg) +
        "</div>" +
        '<div class="pkg-preview-body">' +
        '<div class="title-row"><h3>' + t(pkg.title) + '</h3><span class="price">' + ui("vanaf") + " " + priceFmt(pkg.price) + "</span></div>" +
        '<div class="dates">' + t(pkg.dates) + "</div>" +
        '<div class="route-line">' + planeIcon + "<span>" + t(pkg.departure) + " → " + t(pkg.arrival) + "</span></div>" +
        "</div></div>"
      );
    }).join("");
    if (window.AsfarSite) {
      window.AsfarSite.initPhotoPlaceholders();
      window.AsfarSite.initReveal();
    }
  }

  var state = { period: [], duration: [], priceMax: null, sort: "price-asc" };

  function passesFilters(pkg) {
    if (state.period.length && state.period.indexOf(pkg.month) === -1) return false;
    if (state.duration.length && state.duration.indexOf(String(pkg.duration)) === -1) return false;
    if (state.priceMax && pkg.price > state.priceMax) return false;
    return true;
  }

  function sortPackages(list) {
    var arr = list.slice();
    if (state.sort === "price-asc") arr.sort(function (a, b) { return a.price - b.price; });
    else if (state.sort === "price-desc") arr.sort(function (a, b) { return b.price - a.price; });
    else if (state.sort === "duration-asc") arr.sort(function (a, b) { return a.duration - b.duration; });
    return arr;
  }

  function renderPackageListCard(pkg, i) {
    return (
      '<div class="pkg-list-card reveal" style="transition-delay:' + (i * 60) + 'ms">' +
      '<div class="pkg-list-main">' +
      '<span class="badge" style="display:inline-block;background:var(--gold);color:var(--navy-3);font-size:.65rem;letter-spacing:.06em;text-transform:uppercase;padding:5px 12px;border-radius:999px;font-weight:600;margin-bottom:10px;">' + t(pkg.badge) + "</span>" +
      "<h3>" + t(pkg.title) + "</h3>" +
      '<p class="desc">' + t(pkg.desc) + "</p>" +
      photoPlaceholder(pkg) +
      '<div class="hotels">' +
      "<span>" + bedIcon + " " + pkg.hotelMadinah + "</span>" +
      "<span>" + bedIcon + " " + pkg.hotelMekkah + "</span>" +
      "</div></div>" +
      '<div class="pkg-list-details">' +
      "<div>" + calIcon + "<span>" + t(pkg.dates) + "</span></div>" +
      "<div>" + pinIcon + "<span>" + t(pkg.arrival) + " & " + ui("mekka") + "</span></div>" +
      "<div>" + ticketIcon + "<span>" + ui("visum") + "</span></div>" +
      "<div>" + bedIcon + "<span>" + pkg.stars + "★ " + ui("hotel") + " · " + pkg.airline + "</span></div>" +
      "<div>" + mealIcon + "<span>" + ui("ontbijt") + "</span></div>" +
      "<div>" + busIcon + "<span>" + ui("transport") + "</span></div>" +
      "</div>" +
      '<div class="pkg-list-side">' +
      '<div class="weather">' + sunIcon + " " + pkg.weather + "</div>" +
      '<div class="price-block"><div class="price">' + priceFmt(pkg.price) + '</div><div class="per-person">' + ui("perPersoon") + "</div></div>" +
      '<a class="btn btn-gold btn-sm" href="' + CONTACT_PATH + '?pakket=' + encodeURIComponent(pkg.id) + '">' + ui("boekReis") + "</a>" +
      "</div></div>"
    );
  }

  function renderPackagesPage() {
    var listEl = document.getElementById("pkgList");
    var countEl = document.getElementById("resultCount");
    if (!listEl || typeof ASFAR_PACKAGES === "undefined") return;
    var filtered = sortPackages(ASFAR_PACKAGES.filter(passesFilters));
    countEl.textContent = filtered.length + " " + (filtered.length === 1 ? ui("reisGevonden") : ui("reizenGevonden"));
    if (!filtered.length) {
      listEl.innerHTML = '<div class="no-results">' + ui("geenReizen") + "</div>";
      return;
    }
    listEl.innerHTML = filtered.map(renderPackageListCard).join("");
    if (window.AsfarSite) {
      window.AsfarSite.initPhotoPlaceholders();
      window.AsfarSite.initReveal();
    }
  }

  function initPackagesPageControls() {
    var form = document.getElementById("filterForm");
    if (!form) return;
    form.querySelectorAll('input[name="period"]').forEach(function (cb) {
      cb.addEventListener("change", function () {
        state.period = Array.prototype.slice.call(form.querySelectorAll('input[name="period"]:checked')).map(function (c) { return c.value; });
        renderPackagesPage();
      });
    });
    form.querySelectorAll('input[name="duration"]').forEach(function (cb) {
      cb.addEventListener("change", function () {
        state.duration = Array.prototype.slice.call(form.querySelectorAll('input[name="duration"]:checked')).map(function (c) { return c.value; });
        renderPackagesPage();
      });
    });
    form.querySelectorAll('input[name="pricemax"]').forEach(function (r) {
      r.addEventListener("change", function () {
        state.priceMax = r.value === "all" ? null : Number(r.value);
        renderPackagesPage();
      });
    });
    var sortSelect = document.getElementById("sortSelect");
    if (sortSelect) {
      sortSelect.addEventListener("change", function () {
        state.sort = sortSelect.value;
        renderPackagesPage();
      });
    }
    var resetBtn = document.getElementById("filterReset");
    if (resetBtn) {
      resetBtn.addEventListener("click", function () {
        state = { period: [], duration: [], priceMax: null, sort: "price-asc" };
        form.querySelectorAll('input[type="checkbox"]').forEach(function (c) { c.checked = false; });
        form.querySelectorAll('input[type="radio"][value="all"]').forEach(function (r) { r.checked = true; });
        if (sortSelect) sortSelect.value = "price-asc";
        renderPackagesPage();
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    renderHomePreview("homePkgGrid", 6);
    renderPackagesPage();
    initPackagesPageControls();
  });
  document.addEventListener("asfar:langchange", function () {
    renderHomePreview("homePkgGrid", 6);
    renderPackagesPage();
  });

  window.AsfarPackages = { renderHomePreview: renderHomePreview, renderPackagesPage: renderPackagesPage };
})();
